import EnumClass, { build } from '../EnumClass';
import data, { CopyrightLicenseId, CopyrightLicenseData } from './data';
import * as Translations from './translations';

export class CopyrightLicense extends EnumClass<CopyrightLicenseId, CopyrightLicenseData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: COPYRIGHT_LICENSES,
  getById: getCopyrightLicenseById,
  marshaller: CopyrightLicenseMarshaller,
  codec: CopyrightLicenseCodec,
} = build<CopyrightLicenseId, CopyrightLicenseData, CopyrightLicense>('CopyrightLicenseEnum', data, CopyrightLicense);
